<template>
  <AppDialog :is-open="isDialogOpened"
             size="l"
             ok-only
             :ok-text="$t('common.share')"
             :ok-disabled="getArchiveRightsPending"
             :ok-loading="shareArchivesPending"
             @cancel="closeDialog"
             @ok="share"
  >
    <template #title>{{ $t('archives.dialogs.ArchivesShareDialog.title') }}</template>

    <template #subTitle>
      <span v-t="{
            path: 'archives.dialogs.ArchivesShareDialog.subtitle',
            plural: data.length - 1,
            args: { name: data[0].docName },
          }"
      />
    </template>

    <template #body>
      <ArchivesShareModule
        v-if="!getArchiveRightsPending"
        v-model:value="shareConfig"
      />
      <div v-else class="text-center">
        <v-progress-circular
          style="width: 64px; height: 64px"
          color="primary"
          indeterminate
          size="64"
        />
      </div>
    </template>
  </AppDialog>
</template>

<script>
import { toast } from '@/common/utils/toast'
import { useArchivesStore } from '@/stores/archivesStore'

import AppDialog from '../../common/dialogs/AppDialog.vue'
import { dialogMixin } from '../../mixins/dialogMixin'
import ArchivesShareModule from '../ArchivesShareModule.vue'

export default {
  name: 'ArchivesListShareDialog',
  components: { AppDialog, ArchivesShareModule },
  mixins: [dialogMixin],
  setup() {
    const archivesStore = useArchivesStore()
    return { archivesStore }
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      shareConfig: {
        fileRights: [],
        notifyMessage: '',
        notify: false,
      },
    }
  },
  computed: {
    getArchiveRightsPending () {
      return this.archivesStore.getArchiveRightsPending
    },
    currentArchiveRights () {
      return this.archivesStore.currentArchiveRights
    },
    shareArchivesPending () {
      return this.archivesStore.shareArchivesPending
    },
  },
  async created () {
    // If there is only one archive to share, we will get its initial config
    if (this.data.length === 1) {
      await this.archivesStore.getArchiveRights(this.data[0].id)
      this.shareConfig.fileRights = this.currentArchiveRights.read.users.map((u) => u.id)
    }
  },
  methods: {
    async share () {
      const formData = new FormData()
      formData.append('withUsers', this.shareConfig.fileRights)
      formData.append('notify', this.shareConfig.notify)
      formData.append('notifyMessage', this.shareConfig.notifyMessage)
      formData.append('archives', this.data.map((a) => a.id))
      await this.archivesStore.shareArchives(formData)
      toast.success(this.$t('archives.dialogs.ArchivesShareDialog.success', this.data.length))
      this.closeDialog()
    },
  },
}
</script>
